import * as React from "react";
import { DataSource } from "../types";
import * as Chart from "../../ChartZone.styles";
import { MultiSeriesColumnChart } from "../../../Charts/components/MultiSeriesColumnChart";
import { MetricsType } from "../../../../context/reports/utilities/types";
import { ChartLoader } from "../../../Charts/components/ChartLoader";
import { NoResult } from "../../";
import { Margin } from "../../../Layout/Page";

interface Props {
  dataSource: DataSource;
  type: MetricsType;
  unit: string;
  loading?: boolean;
}

export const RankedYearsFrame: React.FC<Props> = ({
  dataSource,
  type,
  unit,
  loading = true,
}) => {
  return (
    <Chart.Container>
      <Chart.Block>
        <Chart.Header>
          <Chart.Heading>
            <Chart.Title>
              Portfolio {type.toLowerCase()} consumption
            </Chart.Title>
            <Chart.Subtitle>
              Showing annual consumption broken down by month
            </Chart.Subtitle>
          </Chart.Heading>
          <Chart.Controls></Chart.Controls>
        </Chart.Header>
        <Chart.Content>
          {loading ? (
            <ChartLoader />
          ) : dataSource.series.length !== 0 ? (
            <Margin>
              <MultiSeriesColumnChart
                key={type}
                dataSource={dataSource}
                valueDecimals={2}
                valueSuffix={" " + unit}
                yAxisTitle="Consumption (kWh)"
              />
            </Margin>
          ) : (
            <NoResult />
          )}
        </Chart.Content>
      </Chart.Block>
    </Chart.Container>
  );
};
